export default "__VITE_ASSET__f6ac5060__"